/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Настройки для веб пушей
 * @export
 * @interface FxIdDomainSettingsWebPushOptions
 */
export interface FxIdDomainSettingsWebPushOptions {
    /**
     * VAPID публичный ключ. Если используется Notifier - должен совпадать с pubkey/privkey оттуда
     * @type {string}
     * @memberof FxIdDomainSettingsWebPushOptions
     */
    VapidPublicKey: string;
}

/**
 * Check if a given object implements the FxIdDomainSettingsWebPushOptions interface.
 */
export function instanceOfFxIdDomainSettingsWebPushOptions(value: object): value is FxIdDomainSettingsWebPushOptions {
    if (!('VapidPublicKey' in value) || value['VapidPublicKey'] === undefined) return false;
    return true;
}

export function FxIdDomainSettingsWebPushOptionsFromJSON(json: any): FxIdDomainSettingsWebPushOptions {
    return FxIdDomainSettingsWebPushOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsWebPushOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsWebPushOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'VapidPublicKey': json['VapidPublicKey'],
    };
}

export function FxIdDomainSettingsWebPushOptionsToJSON(json: any): FxIdDomainSettingsWebPushOptions {
    return FxIdDomainSettingsWebPushOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsWebPushOptionsToJSONTyped(value?: FxIdDomainSettingsWebPushOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'VapidPublicKey': value['VapidPublicKey'],
    };
}

